import React from "react";

import { useTranslation } from "react-i18next";

import { StyledFilters, StyledTab, StyledTabs } from "./styled";

export interface Filter {
    id: any;
    label: string;
    quantity?: number;
}

type FilterOptionsProps<T> = {
    selectedFilterId: T;
    availableFilters: Filter[];
    onChangeFilter: (selectedFilterId: T) => void;
};

export const FilterOptions = <T,>({
    selectedFilterId,
    availableFilters,
    onChangeFilter,
}: FilterOptionsProps<T>): React.ReactElement => {
    const { t } = useTranslation();
    const handleFilterChange = (_event: React.ChangeEvent<any>, newValue: T) => {
        onChangeFilter(newValue);
    };
    if (availableFilters.length < 2) {
        return <></>;
    }
    return (
        <StyledFilters>
            <StyledTabs
                value={selectedFilterId}
                onChange={handleFilterChange}
                indicatorColor="secondary"
                textColor="secondary"
                variant="scrollable"
                scrollButtons="auto"
                classes={{
                    indicator: "tab-indicator",
                }}
            >
                {availableFilters?.map?.((filter) => (
                    <StyledTab
                        classes={{
                            root: "tab-root",
                            wrapped: "tab-wrapper",
                            selected: "tab-selected",
                        }}
                        data-testid={`filter_option-option-category_${filter.id}`}
                        value={filter.id}
                        key={`filter_option-option-category_${filter.id}`}
                        label={
                            <>
                                {t(filter.label)}{" "}
                                {(!!filter.quantity || filter.quantity === 0) && (
                                    <span className="quantity">{filter.quantity}</span>
                                )}
                            </>
                        }
                    />
                ))}
            </StyledTabs>
        </StyledFilters>
    );
};
